import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const QuestionWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
  padding-bottom: ${Spacing.S32};
  border-bottom: 1px solid ${Color.Grey150};
`

export const TitleWrapper = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
`

export const SideActions = styled.div`
  margin-left: auto;
`
